import type {
  MetricPillDelta,
  DeltaDirection,
} from '@app/shared/vue/components/sf-metric-pill/types'
import type { DrawerGraphSummary } from '@app/application/report/types'

export function formatValue(summary: DrawerGraphSummary): string {
  return summary.valueDisplay ?? '—'
}

export function formatDelta(
  summary: DrawerGraphSummary
): MetricPillDelta | undefined {
  if (!summary.delta) return undefined
  const direction: DeltaDirection = summary.direction ?? 'flat'
  const text = summary.delta.percentDisplay ?? summary.delta.absoluteDisplay
  return { text, direction }
}
